const BankTransactionType = {
	/***************** GET BANK TRANSACTION LIST EXCEL START *************** */
	BANK_TRANSACTION_EXCEL_START: 'bank_transaction_excel_start',
	BANK_TRANSACTION_EXCEL_SUCCESS: 'bank_transaction_excel_success',
	BANK_TRANSACTION_EXCEL_FAILURE: 'bank_transaction_excel_failure',
	BANK_TRANSACTION_EXCEL_RESPONSE_RESET_START: 'bank_transaction_excel_response_reset_start',
	BANK_TRANSACTION_EXCEL_RESPONSE_CHANGED: 'bank_transaction_excel_response_changed',
	/***************** GET  BANK TRANSACTION LIST EXCEL END *************** */

	/*****************  GET BANK  TRANSACTION LIST START  *******************/
	GET_BANK_TRANSACTION_LIST_START: 'get_bank_transaction_list_start',
	GET_BANK_TRANSACTION_LIST_SUCCESS: 'get_bank_transaction_list_success',
	GET_BANK_TRANSACTION_LIST_FAILURE: 'get_bank_transaction_list_failure',
	GET_BANK_TRANSACTION_LIST_RESPONSE_RESET: 'get_bank_transaction_list_response_reset',
	GET_BANK_TRANSACTION_LIST_RESPONSE_CHANGED: 'get_bank_transaction_list_response_changed',
	/*****************  GET BANK  TRANSACTION LIST END  *******************/

	/*****************  ADD BANK  TRANSACTION DETAILS START  *******************/
	ADD_BANK_TRANSACTION_DETAILS_START: 'add_bank_transaction_details_start',
	ADD_BANK_TRANSACTION_DETAILS_SUCCESS: 'add_bank_transaction_details_success',
	ADD_BANK_TRANSACTION_DETAILS_FAILURE: 'add_bank_transaction_details_failure',
	ADD_BANK_TRANSACTION_DETAILS_RESPONSE_RESET: 'add_bank_transaction_details_response_reset',
	ADD_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED: 'add_bank_transaction_details_response_changed',
	/*****************  ADD BANK  TRANSACTION DETAILS END  *******************/

	/*****************  UPDATE BANK  TRANSACTION DETAILS START  *******************/
	UPDATE_BANK_TRANSACTION_DETAILS_START: 'update_bank_transaction_details_start',
	UPDATE_BANK_TRANSACTION_DETAILS_SUCCESS: 'update_bank_transaction_details_success',
	UPDATE_BANK_TRANSACTION_DETAILS_FAILURE: 'update_bank_transaction_details_failure',
	UPDATE_BANK_TRANSACTION_DETAILS_RESPONSE_RESET:
		'update_bank_transaction_details_response_reset',
	UPDATE_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
		'update_bank_transaction_details_response_changed',
	/*****************  UPDATE BANK  TRANSACTION DETAILS END  *******************/

	/*****************  DELETE BANK  TRANSACTION DETAILS START  *******************/
	DELETE_BANK_TRANSACTION_DETAILS_START: 'delete_bank_transaction_details_start',
	DELETE_BANK_TRANSACTION_DETAILS_SUCCESS: 'delete_bank_transaction_details_success',
	DELETE_BANK_TRANSACTION_DETAILS_FAILURE: 'delete_bank_transaction_details_failure',
	DELETE_BANK_TRANSACTION_DETAILS_RESPONSE_RESET:
		'delete_bank_transaction_details_response_reset',
	DELETE_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
		'delete_bank_transaction_details_response_changed',
	/*****************  DELETE BANK  TRANSACTION DETAILS END  *******************/

	/*****************  FETCH BANK  TRANSACTION DETAILS START  *******************/
	FETCH_BANK_TRANSACTION_DETAILS_START: 'fetch_bank_transaction_details_start',
	FETCH_BANK_TRANSACTION_DETAILS_SUCCESS: 'fetch_bank_transaction_details_success',
	FETCH_BANK_TRANSACTION_DETAILS_FAILURE: 'fetch_bank_transaction_details_failure',
	FETCH_BANK_TRANSACTION_DETAILS_RESPONSE_RESET: 'fetch_bank_transaction_details_response_reset',
	FETCH_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
		'fetch_bank_transaction_details_response_changed',
	/*****************  FETCH BANK  TRANSACTION DETAILS END  *******************/
	/********* GET VALUES MODEL - START  *********/
	GET_VALUES_MODEL_START: 'get_values_model_start',
	GET_VALUES_MODEL_SUCCESS: 'get_values_model_success',
	GET_VALUES_MODEL_FAILURE: 'get_values_model_failure',
	GET_VALUES_MODEL_RESPONSE_RESET: 'get_values_model_response_reset',
	GET_VALUES_MODEL_RESPONSE_CHANGED: 'get_values_model_response_changed',
	/********* GET VALUES MODEL- END  *********/

	/********* CHECK BRANCH EOD - START  *********/
	CHECK_BRANCH_EOD_START: 'check_branch_eod_start',
	CHECK_BRANCH_EOD_SUCCESS: 'check_branch_eod_success',
	CHECK_BRANCH_EOD_FAILURE: 'check_branch_eod_failure',
	CHECK_BRANCH_EOD_RESPONSE_RESET: 'check_branch_eod_response_reset',
	CHECK_BRANCH_EOD_RESPONSE_CHANGED: 'check_branch_eod_response_changed',
	/********* CHECK BRANCH EOD- END  *********/

	/********* SELECTED TRANSACTION APPROVE - START  *********/
	SELECTED_TRANSACTION_APPROVE_START: 'selected_transaction_approve_start',
	SELECTED_TRANSACTION_APPROVE_SUCCESS: 'selected_transaction_approve_success',
	SELECTED_TRANSACTION_APPROVE_FAILURE: 'selected_transaction_approve_failure',
	SELECTED_TRANSACTION_APPROVE_RESET: 'selected_transaction_approve_reset',
	SELECTED_TRANSACTION_APPROVE_CHANGED: 'selected_transaction_approve_changed',
	/*********  SELECTED TRANSACTION APPROVE- END  *********/
};
export default BankTransactionType;
